"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var axios_1 = __importDefault(require("axios"));
var react_1 = __importStar(require("react"));
var react_query_1 = require("react-query");
var react_router_dom_1 = require("react-router-dom");
var MessageContext_1 = __importDefault(require("@/frontend/react/context/MessageContext"));
var NotificationContext_1 = __importDefault(require("@/frontend/react/context/NotificationContext"));
var MessageList_1 = __importDefault(require("@/frontend/react/connections/chats/MessageList"));
var material_1 = require("@mui/material");
function ApplicationChatContainer() {
    var applicationParam = (0, react_router_dom_1.useParams)().applicationId;
    var _a = (0, react_1.useContext)(MessageContext_1.default), messages = _a.messages, setMessages = _a.setMessages, setCurrentConversationId = _a.setCurrentConversationId;
    var _b = (0, react_1.useContext)(NotificationContext_1.default), clearNotification = _b.clearNotification, notifications = _b.notifications;
    var _c = (0, react_query_1.useQuery)(['applicationChat', applicationParam], function () { return axios_1.default.get("/data/applications/".concat(applicationParam, "/chat")).then(function (result) { return result.data; }); }, {
        onSuccess: function (data) {
            setCurrentConversationId(data.id);
            setMessages(data.messages);
        },
    }), isLoading = _c.isLoading, chat = _c.data;
    var applicationId = (0, react_1.useMemo)(function () {
        if (applicationParam) {
            return Number(applicationParam);
        }
        return undefined;
    }, [applicationParam]);
    (0, react_1.useEffect)(function () {
        if (applicationId && chat) {
            var hasNotification = typeof notifications.applications[applicationId] !== 'undefined';
            if (hasNotification) {
                clearNotification('applications', applicationId, chat.id);
            }
        }
    }, [applicationId, clearNotification, notifications.applications, chat]);
    if (isLoading) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(material_1.Box, __assign({ sx: {
            borderTop: '1px solid',
            borderColor: 'primary.main',
        } }, { children: (0, jsx_runtime_1.jsx)(MessageList_1.default, { chatId: chat.id, messages: messages }) })));
}
exports.default = ApplicationChatContainer;
